import { render, staticRenderFns } from "./FormulateSuggestion.vue?vue&type=template&id=dc796874&"
import script from "./FormulateSuggestion.vue?vue&type=script&lang=js&"
export * from "./FormulateSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./FormulateSuggestion.vue?vue&type=style&index=0&id=dc796874&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports